import { postToIOSBridge } from '@/Utils/IosBridgeUtility';

export function iOSPushPermissionRequest() {
    postToIOSBridge('push-permission-request');
}

export function getIOSPushToken() {
    postToIOSBridge('push-token');
}

export function iOSPushCapability() {
    const handlers = window.webkit?.messageHandlers;
    return handlers?.['push-permission-request'] && handlers?.['push-permission-state'];
}

export function getIOSPushPermissionState() {
    postToIOSBridge('push-permission-state');
}

export function requestIOSAppReview() {
    postToIOSBridge('request-review');
}
